import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { IrcpProjeto } from '../../models/ircp-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IrcpProjetoService } from '../../services/ircp-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-ircp-list',
  templateUrl: './detalhe-projeto-ircp-list.component.html',
  styleUrls: ['./detalhe-projeto-ircp-list.component.scss']
})
export class DetalheProjetoIrcpListComponent extends BaseListComponent<IrcpProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  dtResposta: any = {};
  canSave: boolean = false;
  ircpList: IrcpProjeto[];
  permission: any;

  constructor(
    private myService: IrcpProjetoService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initLoadDataTable();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getListAll(this.idProjeto).subscribe((res) => {
        this.ircpList = res['ircpList'];
        this.permission = res['permission'];
        this.loaded();
      })
    );
  }
}
